const scrollTop = document.getElementById('scroll__top');

if (scrollTop) {
scrollTop.addEventListener('click', function(){
  window.scroll({top: 0, left: 0, behavior: 'smooth'});
}) 

let nsmScrollTopScheduled = false;
let nsmScrollTopActive = scrollTop.classList.contains('active');
function updateScrollTop() {
  nsmScrollTopScheduled = false;
  const next = window.scrollY > 300;
  if (next !== nsmScrollTopActive) {
    nsmScrollTopActive = next;
    scrollTop.classList.toggle('active', next);
  }
}
window.addEventListener('scroll', function(){
  if (nsmScrollTopScheduled) return;
  nsmScrollTopScheduled = true;
  requestAnimationFrame(updateScrollTop);
}, { passive: true });
updateScrollTop();
}
